import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ShopDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL + '/'

        return <div className="ltn__shop-details-area pb-10">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
                           
                            <h1 >KKR City</h1>
                            <label><span className="ltn__secondary-color"><i className="flaticon-pin" /></span> Mambakkam,Chengalpattu</label>
                            
                            {/* <p> Welcome to METRRO CITY, Manimangalam by Success Property!

                                Looking for the perfect place to build your dream home? Look no further! METRRO CITY in the serene and developing locality of Manimangalam offers premium residential plots tailored to your lifestyle and investment needs.</p> */}
                           
                            <div className="ltn__property-details-gallery mb-30 mt-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <a href="" data-rel="lightcase:myCollection">
                                            <img className="mb-30" src={publicUrl + "assets/img/projects/KKR City/img1.jpg"} alt="Image" />
                                        </a>
                                    </div>
                                    <div className="col-md-6">
                                        <a href="" data-rel="lightcase:myCollection">
                                            <img className="mb-30" src={publicUrl + "assets/img/projects/KKR City/img3.jpg"} alt="Image" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <h4 className="title-2">Property Details</h4>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 section-bg-1">
                                    <div className="prop-main-cont">
                                    <div className="left-cont">
                                        <p>Sold Rate:</p>
                                        <p>Sold Year:</p>
                                        <p>Current Market Price:</p>
                                        <p>Total No of Plot:</p>
                                        <p>No of Plots Sold:</p>
										<p>Approval:</p>
                                    </div>
                                    <div className="right-cont">
                                        <p>500 Per Sqft</p>
                                        <p>2022</p>
                                        <p className="head-mine">1200 Per Sqft</p>
                                        <p>382</p>
                                        <p>Sold Out</p>
										<p>DTCP</p>
                                    </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="search-by-place-imgs">
                                        <img src={publicUrl + "assets/img/projects/KKR City/img5.jpg"} alt="#" />
                                    </div>
                                </div>
                            </div>
                        
                            <h4 className="title-2 mb-10">Amenities</h4>
                            <div className="property-details-amenities mb-60">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="ltn__menu-widget">
                                            <ul>
                                                <li>
                                                    <label className="checkbox-item">Site near by Amala Annai High School, 
                                                        <input type="checkbox" defaultChecked="checked" />
                                                        <span className="checkmark" />
                                                    </label>
                                                </li>
                                                <li>
                                                    <label className="checkbox-item">Site near by  Maharishi Vidya Mandir School & Govt school
                                                        <input type="checkbox" defaultChecked="checked" />
                                                        <span className="checkmark" />
                                                    </label>
                                                </li>
                                                <li>
                                                    <label className="checkbox-item"> Site near by Masque, Kanni Amman Temple & Church
                                                        <input type="checkbox" defaultChecked="checked" />
                                                        <span className="checkmark" />
                                                    </label>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="ltn__menu-widget">
                                            <ul>
                                                <li>
                                                    <label className="checkbox-item"> Site near by Malls, Banks & Mtc Bus Facilities.
                                                        <input type="checkbox" defaultChecked="checked" />
                                                        <span className="checkmark" />
                                                    </label>
                                                </li>
                                                <li>
                                                    <label className="checkbox-item">Site very closely Govt Hospital just 1-km
                                                        <input type="checkbox" defaultChecked="checked"/>
                                                        <span className="checkmark" />
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <h4 className="title-2">Property Video</h4>
                            <div className="ltn__video-bg-img ltn__video-popup-height-500 bg-overlay-black-50 bg-image mb-60" data-bs-bg={publicUrl + "assets/img/others/5.jpg"}>
                                <a className="ltn__video-icon-2 ltn__video-icon-2-border---" target="blank" href="https://www.youtube.com/watch?v=7alzSjnlBLU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
                                    <i className="fa fa-play" />
                                </a>
                            </div> */}
                            <h4 className="title-2">Location</h4>
                            <div className="property-details-google-map mb-60">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3892.013311781856!2d79.904093!3d12.712553999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDQyJzQ1LjIiTiA3OcKwNTQnMTQuNyJF!5e0!3m2!1sen!2sin!4v1734679771404!5m2!1sen!2sin" width="100%" height="100%" frameBorder={0} allowFullScreen aria-hidden="false" tabIndex={0} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    }
}

export default ShopDetails